import { render, staticRenderFns } from "./WidgetsList.vue?vue&type=template&id=847c5414"
import script from "./WidgetsList.vue?vue&type=script&lang=js"
export * from "./WidgetsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports